module.exports = __webpack_public_path__ + "img/checkmark-done-outline.4002bbff.svg";